<lib-panel-layout>
  @if (selectedType === null) {
    <div class="grid w-full grid-cols-2 gap-2 lg:grid-cols-1">
      @for (button of buttons; track button) {
        <button
          libButton
          variant="primary"
          size="xs"
          type="button"
          class="w-full justify-start gap-2"
          (click)="onFilterTypeSelected(button)">
          <mat-icon
            class="size-4! shrink-0"
            svgIcon="question_circle"
            [matTooltip]="button.description"
            [matTooltipPosition]="tooltipPosition">
          </mat-icon>
          <span class="noselect truncate">{{ button.title | translate }}</span>
        </button>
      }
    </div>
  }
  @if (selectedType !== null) {
    <div class="flex w-full flex-col gap-2">
      <div class="filter-options-header flex flex-col w-full items-center gap-2">
        <button
          libButton
          variant="primary"
          size="xs"
          type="button"
          class="shrink-0 px-2 text-white self-start"
          aria-label="Back"
          (click)="onBackToFilterList()">
          &lt;
        </button>
        <div
          class="panel-button w-full flex min-w-0 flex-1 gap-2 flex-row items-center rounded-full px-4 py-2 justify-between text-sm">
          <span class="noselect">{{ selectedType.title | translate }}</span>
          <mat-icon
            class="question-icon"
            svgIcon="question_circle"
            [matTooltip]="selectedType.description"
            [matTooltipPosition]="tooltipPosition">
          </mat-icon>
        </div>
      </div>
      @if (selectedType.options) {
        <lib-backend-filter-options [config]="selectedType.options" (filterArgsChanged)="onFilterArgsChanged($event)">
        </lib-backend-filter-options>
      }
    </div>
  }

  @if (selectedType !== null) {
    <lib-apply-panel panelActions class="w-full" (apply)="applyFilterOptions()" (cancelRequested)="onCancel()">
    </lib-apply-panel>
  }
</lib-panel-layout>
